import { People } from "@mui/icons-material";
import { avatarImages } from "../data/avatarsData";
import Header from "../components/Header";
import MainFrame from "../components/MainFrame";
import GenericModal from "../components/GenericModal";
import useTheGroups from "./useTheGroups";
import ButtonsBar from "./components/ButtonsBar";
import InactiveScreen from "./components/InactiveScreen";
import GridScreen from "./components/GridScreen";
import DraggingItem from "./components/DraggingItem";
import SelectionBox from "./components/SelectionBox";
import TerritoriesList from "./components/TerritoriesList";
import MapScreen from "./components/MapScreen";

export default function TheGroups(props) {
  const {
    subMenuButtons,
    formattedDate,
    headerInfo,
    status,
    openActivity,
    btns,
    iconList,
    handleLock,
    avatarsList,
    setOpenModal,
    dragId,
    openModal,
    openInput,
    newPerson,
    isDragging,
    position,
    selectionData,
    search,
    setSearch,
    avatarsBox,
    mapElement,
    writeIcons,
    territories,
    setHeaderInfo,
    closeInput,
    avatarsData,
  } = useTheGroups(props);

  return (
    <MainFrame width={props.width}>
      <Header
        MainIcon={People}
        color={props.iconColor}
        subMenu={subMenuButtons}
      >
        <ButtonsBar formattedDate={formattedDate} headerInfo={headerInfo} />
      </Header>
      {status === "ready" ? (
        <GridScreen
          btns={btns}
          iconList={iconList}
          handleLock={handleLock}
          avatarsList={avatarsList}
          setOpenModal={setOpenModal}
          dragId={dragId}
        />
      ) : (
        <InactiveScreen status={status} openActivity={openActivity} />
      )}
      <TerritoriesList
        btns={btns}
        headerInfo={headerInfo}
        territories={territories}
        openMap={props.openMap}
        setHeaderInfo={setHeaderInfo}
      />
      <MapScreen
        headerInfo={headerInfo}
        btns={btns}
        writeIcons={writeIcons}
        mapElement={mapElement}
      />
      <DraggingItem
        isDragging={isDragging}
        position={position}
        dragId={dragId}
        avatarImages={avatarImages}
      />
      {openModal.status && (
        <SelectionBox
          openModal={openModal}
          selectionData={selectionData}
          closeInput={closeInput}
          search={search}
          setSearch={setSearch}
          avatarsBox={avatarsBox}
          setOpenModal={setOpenModal}
          avatarsData={avatarsData}
        />
      )}
      {openInput.status && (
        <GenericModal open={openInput.status} data={newPerson} />
      )}
    </MainFrame>
  );
}
